export interface OverrideProctoringSetting {
    enableFaceDetection?: boolean;
    appDetection?: boolean;
    isExternalDeviceConnected?: boolean;
}

export class AdminPermissionDto {
    id?: string;
    audio?: boolean;
    video?: boolean;
    screenShare?: boolean;
    devicesCompatibilityCheck?: boolean;
    aadharPhotoCapture?: boolean;
    autoSubmitAfterTimeUp?: boolean;
    fullScreenMode?: boolean;
    tabLimit?: boolean;
    disableCopy?: boolean;
    disablePaste?: boolean;
    disableScreenshot?: boolean;
    mobileFeedCapture?: boolean;
    verifySurroundings?:boolean
    isExtensionInstalled?:boolean
    // when a flag here is explicitly false, keep detecting/capturing but stop blocking the candidate on it
    overrideProctoringSetting?: OverrideProctoringSetting;
    //     AssesmentDto assesment;

}

export class AssessmentPermissionDto {
    id?: string;
    audio?: boolean = true;
    video?: boolean = true;
    screenShare?: boolean = true;
    devicesCompatibilityCheck?: boolean = true;
    aadharPhotoCapture?: boolean = true;
    autoSubmitAfterTimeUp?: boolean = true;
    fullScreenMode?: boolean = true;
    tabLimit?: boolean = true;
    disableCopy?: boolean = true;
    disablePaste?: boolean = true;
    disableScreenshot?: boolean = true;
    mobileFeedCapture?: boolean = true;
    verifySurroundings?:boolean = true;
    //     AssesmentDto assesment;

}